import styled from 'styled-components';
import Modal from 'antd/lib/modal';

export const StyledSmartIdModal = styled(Modal)`
  .ant-modal-body {
    padding-top: 20px;
    .action {
      display: flex;
      justify-content: right;
    }

    .smart-id {
      border: 1px solid;
      border-radius: 8px;
      padding: 10px;
      background-color: ${(props) => props.theme.goldenYellow};
      border-color: ${(props) => props.theme.goldenYellow};

      .title {
        display: flex;
        justify-content: center;
      }

      .confirm-code {
        display: flex;
        justify-content: center;
        font-size: 30px;
      }
    }
  }

  .ant-btn {
    padding: 20px;
  }
`;
